import styled from 'styled-components'

export const FieldWrapper = styled.div`
  margin: ${({ theme }) => theme.mp.md} 0;

  & > div:first-child {
    margin-bottom: ${({ theme }) => theme.mp.xs};
  }
`

export const DropdownWrapper = styled.div`
  width: 130px;
`
